import { IconChevronLeft, IconClock } from '@tabler/icons-react';
import { useNavigate } from 'react-router-dom';
import { useTranslation } from '../../../i18n/hooks/useTranslation';

// Generic placeholder page for tools that aren't built yet.
export default function ComingSoon({ titleKey, descKey }) {
    const navigate = useNavigate();
    const { t } = useTranslation();

    return (
        <div className="w-full font-hind space-y-5 py-2 sm:py-4">
            <button
                onClick={() => navigate('/tools')}
                className="inline-flex items-center gap-1 text-[13px] font-medium text-zinc-500 dark:text-zinc-400 hover:text-zinc-700 dark:hover:text-zinc-200 transition-colors mb-3"
            >
                <IconChevronLeft size={15} /> {t('sohozJob.backToTools')}
            </button>

            <h1 className="text-xl sm:text-2xl font-bold text-zinc-900 dark:text-zinc-100 tracking-tight">
                {titleKey ? t(titleKey) : ''}
            </h1>

            <div className="bg-white dark:bg-zinc-900 border border-zinc-200 dark:border-zinc-700 rounded-2xl py-20 text-center shadow-sm">
                <div className="flex flex-col items-center gap-3">
                    <span className="w-14 h-14 rounded-2xl bg-primary/10 text-primary flex items-center justify-center">
                        <IconClock size={28} stroke={1.6} />
                    </span>
                    <p className="text-base font-semibold text-zinc-700 dark:text-zinc-200">{t('toolsPage.comingSoonTitle')}</p>
                    <p className="text-sm text-zinc-400 dark:text-zinc-500 max-w-md">{t(descKey || 'toolsPage.comingSoonDesc')}</p>
                </div>
            </div>
        </div>
    );
}
